import { Card, CardContent, CardHeader, CardTitle } from '@repo/shadcn';

import { CustomerTypeBadge } from '@/components/ui/badge';

import { useCustomerDetailsContext } from './context';

export const CustomerInfo = () => {
    const { data } = useCustomerDetailsContext();

    return (
        <Card>
            <CardHeader className="p-4 sm:p-6">
                <CardTitle>Customer Information</CardTitle>
            </CardHeader>
            <CardContent className="grid grid-cols-1 gap-3 p-4 pt-0 sm:grid-cols-2 sm:p-6 sm:pt-0">
                <div className="min-w-0">
                    <span className="text-sm text-muted-foreground">Name</span>
                    <p className="break-words">{data?.name}</p>
                </div>
                <div className="min-w-0">
                    <span className="text-sm text-muted-foreground">Email</span>
                    <p className="break-all">{data?.email}</p>
                </div>

                <div className="min-w-0">
                    <span className="text-sm text-muted-foreground">Phone</span>
                    <p className="break-words">{data?.phone_number}</p>
                </div>
                <div className="min-w-0">
                    <span className="text-sm text-muted-foreground">
                        Address
                    </span>
                    <p className="break-words">{data?.address}</p>
                </div>

                <div className="flex flex-col items-start justify-start gap-0.5">
                    <span className="block text-sm text-muted-foreground">
                        Customer Type
                    </span>
                    <CustomerTypeBadge value={data?.customer_type} />
                </div>

                <div className="flex flex-col items-start justify-start gap-0.5">
                    <span className="block text-sm text-muted-foreground">
                        Member Since
                    </span>
                    <p>{new Date(data?.created_at ?? '').toDateString()}</p>
                </div>
            </CardContent>
        </Card>
    );
};

CustomerInfo.displayName = 'CustomerInfo';
